module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/placeholder_9f014f.jpg";